/**
 * Stable erp_records.data keys from tracking items — no semantic HK/meal field names.
 * Standalone module to avoid circular imports with builtinCustomMasterData.
 * Keep in lockstep with erp_api/routes/controllers/trackerFieldKey.ts.
 */
export type TrackerFieldInputType =
  | 'text'
  | 'yes_no'
  | 'calendar'
  | 'number'
  | 'percent'
  | 'private_picture'
  | 'picture_url';

export const trackerFieldKey = (
  trackingItem: string,
  inputType: TrackerFieldInputType = 'text',
): string => (
  inputType === 'yes_no' || inputType === 'text'
    ? trackingItem
    : `${trackingItem}__${inputType}`
);
